export function initializeDeleteConfirm(appManager: any) {
    let appIdToDelete: string | null = null;

    const modalHTML = `
        <div class="modal-backdrop"></div>
        <div class="glassmorphic p-6 md:p-8 rounded-xl shadow-2xl w-full max-w-md relative z-10">
            <div class="flex items-start mb-4">
                <div class="mr-4 flex-shrink-0 mt-1">
                    <i class="ph-warning text-4xl text-red-400"></i>
                </div>
                <div>
                    <h2 id="deleteConfirmTitle" class="text-xl font-semibold text-slate-100">Confirm Deletion</h2>
                    <p id="deleteConfirmMessage" class="text-slate-300 mt-1 text-sm">Are you sure? This action cannot be undone.</p>
                </div>
            </div>
            <div class="flex justify-end space-x-3 mt-6">
                <button type="button" id="cancelDeleteBtn" class="btn btn-secondary">Cancel</button>
                <button type="button" id="confirmDeleteBtn" class="btn btn-warning">Delete</button>
            </div>
        </div>
    `;

    const deleteConfirmModal = document.getElementById('deleteConfirmModal');
    if (!deleteConfirmModal) return { showDeleteConfirm: () => {} };
    deleteConfirmModal.innerHTML = modalHTML;

    const modal = document.getElementById('deleteConfirmModal');
    const message = document.getElementById('deleteConfirmMessage');
    const confirmBtn = document.getElementById('confirmDeleteBtn') as HTMLButtonElement | null;
    const cancelBtn = document.getElementById('cancelDeleteBtn');

    const showDeleteConfirm = (appId: string, appName: string = "this application") => {
        appIdToDelete = appId;
        if (message) message.textContent = `Are you sure you want to delete the application for "${appName}"? This action cannot be undone.`;
        if (modal) {
            modal.classList.remove('hidden');
            (modal as HTMLElement).style.display = 'flex';
            setTimeout(() => modal.classList.add('active'), 10);
        }
    };

    const hideDeleteConfirm = () => {
        if (modal) {
            modal.classList.remove('active');
            setTimeout(() => {
                modal.classList.add('hidden');
                (modal as HTMLElement).style.display = 'none';
            }, 300);
        }
        appIdToDelete = null;
    };

    if (cancelBtn) cancelBtn.addEventListener('click', hideDeleteConfirm);
    if (modal) modal.addEventListener('click', (e) => {
        if (e.target === modal) hideDeleteConfirm();
    });

    if (confirmBtn) confirmBtn.addEventListener('click', async () => {
        if (appIdToDelete) {
            confirmBtn.disabled = true;
            confirmBtn.textContent = 'Deleting...';
            const success = await appManager.deleteApplication(appIdToDelete);
            if (success) {
                hideDeleteConfirm();
            }
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'Delete';
        }
    });

    return { showDeleteConfirm };
}